<template>
  <div class="wall mes_container">
    <div class="wall-head">热销商品</div>
    <ul class="fs-12 color-sliver" v-loading="loading">
      <li class="d-flex p-20" v-for="(item, index) in productList" :key="index">
        <div class="flex-body-line mr-20">
          <router-link to="/product">
            {{ index + 1 }}、{{ item.title }}
          </router-link>
        </div>
        <div class="ml-auto sale-item">月销：{{ item.sales }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getProductList } from '@/api/product.js'
export default {
  data () {
    return {
      loading: false,
      productList: []
    }
  },
  created() {
    if (this.$store.getters.hasPermission('view_goods')) {
      this.loadProductList()
    }
  },
  methods: {
    // 加载商品列表
    async loadProductList() {
      this.loading = true
      let params = {limit: 5, offset: 0}
      let { results } = await getProductList(params)
      this.loading = false
      this.productList = results
    },
  }
}
</script>

<style lang="scss" scoped>
.mes_container {
  ul{
    li{
      padding-bottom: 10px;
      border-bottom: 1px dashed rgba(235, 235, 241, 1);
    }
    li:last-child{
      border-bottom: none;
    }
  }
}
</style>
